import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = {
    preventSubmit: Boolean
  }

  declare readonly preventSubmitValue: boolean

  connect() {
    // Initialize any setup if needed
  }

  submit(event: Event) {
    event.preventDefault()
    const form = event.target as HTMLFormElement
    const formData = new FormData(form)
    const filters: { [key: string]: string } = {}

    formData.forEach((value, key) => {
      if (key.startsWith('filters')) {
        const filterKey = key.replace('filters[', '').replace(']', '')
        if (value) {
          filters[filterKey] = value.toString()
        }
      }
    })

    const preventSubmit = this.preventSubmitValue

    if (preventSubmit) {
      // For map view: dispatch event and close drawer
      document.dispatchEvent(new CustomEvent('resources:filtered', {
        detail: { filters }
      }))

      // Close drawer
      const drawer = document.getElementById('drawerToggle') as HTMLInputElement
      if (drawer) drawer.checked = false
    } else {
      // For list view: submit form normally
      form.submit()

      // Close drawer
      const drawer = document.getElementById('drawerToggle') as HTMLInputElement
      if (drawer) drawer.checked = false
    }
  }

  clearFilters(event: Event) {
    event.preventDefault()
    const preventSubmit = this.preventSubmitValue

    if (preventSubmit) {
      // For map view: dispatch event with no filters
      document.dispatchEvent(new CustomEvent('resources:filtered', {
        detail: { filters: null }
      }))

      // Close drawer
      const drawer = document.getElementById('drawerToggle') as HTMLInputElement
      if (drawer) drawer.checked = false
    } else {
      // For list view: redirect to base path
      const url = new URL(window.location.pathname, window.location.origin)
      url.searchParams.set('view', 'list')
      Turbo.visit(url.toString(), { action: 'advance' })

      // Close drawer
      const drawer = document.getElementById('drawerToggle') as HTMLInputElement
      if (drawer) drawer.checked = false
    }
  }
}
